export const CHECKOUT_URL = 'https://ruta.impultienda.ar/checkout/ferlitidad'

export const IMAGES = {
  mockup: 'https://cdn.magicpatterns.com/uploads/8VyT8gDipjUZNyR6Gzvrkp/FERTILIDAD.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/7VXv8sb7NM8wAxRyZbSbyN/BONO_1_FERTILIDAD.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/4QWqPFwLswYQfWSRA6q9gb/BONO_2_FERTILIDAD.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/49wHVTxTGRDy4piByN93SC/BONO_3_FERTILIDAD.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/uqQJkDwcDFthCGmriX8Sjq/BONO_4_FERTILIDAD.png',
  bono5: 'https://cdn.magicpatterns.com/uploads/akco7XW3zys3rd4NYDtWnd/BONO_5_FERTILIDAD.png',
  karito: 'https://cdn.magicpatterns.com/patterns/generated-images/07675f9a-367b-44e9-9091-d7a8f0d12bb4.jpg',
}

export const stats = [
  { value: '+300', label: 'páginas clínicas' },
  { value: '+1.000', label: 'profesionales ya la utilizan' },
  { value: '+1.200', label: 'horas de búsqueda ahorradas al año' },
  { value: '98%', label: 'se siente más seguro al decidir' },
]

export const beforeItems = [
  'Pasas horas revisando guías extensas para encontrar una respuesta.',
  'Dudas al interpretar un espermograma complejo.',
  'Sientes inseguridad al indicar hCG, SERMs o tratar pacientes con antecedentes de esteroides.',
  'Solicitas estudios sin un orden definido o en el momento incorrecto.',
  'Cada consulta depende de lo que recuerdas en ese momento.',
  'Tus pacientes perciben dudas y buscan una segunda opinión.',
]

export const afterItems = [
  'Encuentras la conducta adecuada en minutos gracias a una ruta clínica organizada.',
  'Comprendes rápidamente qué significan los hallazgos y cuál es el siguiente paso.',
  'Utilizas protocolos claros y respaldados por evidencia para cada escenario clínico.',
  'Sabes exactamente qué solicitar, cuándo hacerlo y cómo interpretar cada resultado.',
  'Sigues un algoritmo clínico que elimina la incertidumbre en cada etapa.',
  'Tus pacientes reciben un plan claro y confían más en tu criterio profesional.',
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'Recibes a un paciente con un espermograma alterado y, aunque conoces la teoría, no tienes claridad sobre cuál debe ser la siguiente decisión clínica.',
  },
  {
    emoji: '⏱️',
    text: 'Inviertes demasiado tiempo buscando la dosis correcta de hCG, Clomifeno o SERMs entre diferentes fuentes antes de sentirte seguro para prescribir.',
  },
  {
    emoji: '🤔',
    text: 'No siempre es fácil decidir cuándo iniciar tratamiento, cuándo solicitar estudios adicionales o cuándo derivar a cirugía o reproducción asistida.',
  },
  {
    emoji: '📉',
    text: 'Sientes que podrías aportar mucho más valor en consulta si tuvieras un método claro que guiara cada decisión clínica.',
  },
  {
    emoji: '😓',
    text: 'Al terminar el día, sigues pensando en casos complejos porque no tienes la certeza de haber elegido la mejor estrategia para tu paciente.',
  },
  {
    emoji: '💻',
    text: 'Continúas estudiando información dispersa entre artículos, consensos y guías cuando podrías tener todo organizado en un único sistema de decisión.',
  },
]

export const tomos = [
  {
    numero: 'TOMO I',
    titulo: 'La Primera Decisión',
    promesa: 'Descubre la verdadera causa del problema antes de elegir un tratamiento equivocado.',
    detalle:
      'Aprende a realizar una evaluación clínica estratégica desde el primer contacto con el paciente mediante una anamnesis dirigida y un examen físico que revela las señales más importantes para llegar a un diagnóstico preciso.',
  },
  {
    numero: 'TOMO II',
    titulo: 'Descifrando el Código de la Fertilidad',
    promesa: 'Interpreta el espermograma como un especialista y descubre lo que los resultados realmente indican.',
    detalle:
      'Analiza el espermograma bajo los criterios OMS 6, comprende el verdadero impacto de la fragmentación del ADN espermático y transforma un informe complejo en decisiones clínicas claras.',
  },
  {
    numero: 'TOMO III',
    titulo: 'El Mapa de las Causas Ocultas',
    promesa: 'Identifica el origen hormonal y genético antes de iniciar cualquier tratamiento.',
    detalle:
      'Descubre cuándo solicitar estudios hormonales, cariotipo y microdeleciones del cromosoma Y, e interpreta correctamente el eje hipotálamo-hipófisis-testículo.',
  },
  {
    numero: 'TOMO IV',
    titulo: 'El Protocolo para Recuperar la Fertilidad',
    promesa: 'Domina las estrategias terapéuticas respaldadas por evidencia para restaurar la función reproductiva.',
    detalle:
      'Aprende cuándo utilizar Clomifeno, hCG, FSH y otras alternativas terapéuticas, incluyendo protocolos específicos para pacientes con antecedentes de testosterona o uso de esteroides.',
  },
  {
    numero: 'TOMO V',
    titulo: 'Los Factores que También Determinan el Resultado',
    promesa: 'Descubre qué intervenciones realmente mejoran la fertilidad y cuáles solo hacen perder tiempo y dinero.',
    detalle:
      'Aprende cuándo un varicocele requiere cirugía, qué suplementos cuentan con respaldo científico y cómo optimizar los factores modificables que impactan la calidad espermática.',
  },
  {
    numero: 'TOMO VI',
    titulo: 'La Ruta hacia el Embarazo',
    promesa: 'Integra todo el proceso clínico y toma la decisión correcta en cada etapa.',
    detalle:
      'Utiliza algoritmos visuales y casos clínicos reales para saber cuándo continuar el tratamiento, cuándo derivar a reproducción asistida y cómo acompañar al paciente hasta el siguiente paso.',
  },
]

export const deliverables = [
  {
    emoji: '📘',
    titulo: 'La Ruta Clínica Completa',
    texto:
      'Los 6 tomos organizados en un recorrido lógico que te guía desde la evaluación inicial hasta el tratamiento, seguimiento o derivación del paciente.',
  },
  {
    emoji: '📋',
    titulo: 'Protocolos listos para aplicar',
    texto:
      'Esquemas prácticos de hCG, SERMs, FSH y estrategias respaldadas por evidencia, para que sepas exactamente cuándo y cómo utilizarlos con seguridad.',
  },
  {
    emoji: '🔬',
    titulo: 'Guías de interpretación clínica',
    texto:
      'Aprende qué estudios solicitar, en qué momento pedirlos y cómo interpretar cada resultado sin omitir información importante.',
  },
  {
    emoji: '🗺️',
    titulo: 'Algoritmos de decisión clínica',
    texto:
      'Diagramas visuales que te muestran el siguiente paso en cada escenario, reduciendo la incertidumbre y acelerando la toma de decisiones.',
  },
  {
    emoji: '📚',
    titulo: 'Casos clínicos reales',
    texto:
      'Comprende cómo resolver situaciones complejas usando el mismo razonamiento que emplean los especialistas en medicina reproductiva.',
  },
]

export interface Bono {
  numero: string
  nombre: string
  promesa: string
  texto: string
  bullets?: string[]
  valor: string
  imagen?: string
}

export const bonos: Bono[] = [
  {
    numero: 'Bono #1',
    nombre: 'Diagnóstico en 60 Segundos™',
    promesa: 'Interpreta cualquier espermograma con seguridad en menos de un minuto.',
    texto:
      'Olvídate de revisar tablas interminables de la OMS. Con este sistema visual tipo semáforo identificas rápidamente si los parámetros están en rango normal o requieren intervención clínica.',
    bullets: [
      'Menos tiempo interpretando.',
      'Más seguridad al explicar los resultados.',
      'Mayor confianza frente al paciente.',
    ],
    valor: 'USD 19',
    imagen: IMAGES.bono1,
  },
  {
    numero: 'Bono #2',
    nombre: 'Protocolo Rescate de Fertilidad™',
    promesa: 'La estrategia paso a paso para pacientes que utilizaron testosterona o esteroides.',
    texto:
      'Aprende cómo recuperar la espermatogénesis mediante protocolos claros con hCG y SERMs respaldados por evidencia. Sabrás exactamente qué hacer para aumentar las probabilidades de recuperación sin improvisar.',
    valor: 'USD 37',
    imagen: IMAGES.bono2,
  },
  {
    numero: 'Bono #3',
    nombre: 'Kit de Educación para el Paciente™',
    promesa: 'Ahorra tiempo en consulta y mejora la adherencia al tratamiento.',
    texto:
      'Material visual listo para imprimir o enviar por WhatsApp con recomendaciones sobre nutrición, hábitos, calor testicular y factores ambientales que afectan la fertilidad masculina.',
    valor: 'USD 27',
    imagen: IMAGES.bono3,
  },
  {
    numero: 'Bono #4',
    nombre: 'La Fórmula Antioxidante Basada en Evidencia™',
    promesa: 'Descubre qué suplementos realmente aportan beneficios y cuáles solo generan falsas expectativas.',
    texto:
      'Conoce cuándo utilizar Zinc, CoQ10, Carnitinas, Selenio y otros antioxidantes, en qué dosis recomendarlos y qué evidencia respalda cada intervención.',
    valor: 'USD 20',
    imagen: IMAGES.bono4,
  },
  {
    numero: 'Bono #5',
    nombre: 'Árbol Maestro de Decisiones™',
    promesa: 'El mapa visual que resume toda la Ruta en una sola hoja.',
    texto:
      'Desde la primera consulta hasta la decisión de continuar el tratamiento o derivar a reproducción asistida: una guía visual que conecta todo el proceso clínico.',
    valor: 'USD 37',
    imagen: IMAGES.bono5,
  },
]

export const testimonios = [
  {
    nombre: 'Dra. Marcela P.',
    pais: 'Colombia 🇨🇴',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/3a85d934-ae46-467b-853c-6a8069fec4c0.jpg',
    texto:
      'Después de años atendiendo pacientes con infertilidad masculina, este material logró algo que ningún libro había conseguido: organizar todo el proceso clínico en una ruta clara y fácil de aplicar. Hoy llego a consulta con mucha más seguridad.',
  },
  {
    nombre: 'Dr. Javier M.',
    pais: 'México 🇲🇽',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/5c39b988-2812-4426-83db-b5f8ffb8369f.jpg',
    texto:
      'El sistema visual para interpretar el espermograma cambió completamente mi forma de trabajar. Ahora puedo explicar los resultados con seguridad y definir el siguiente paso en cuestión de minutos.',
  },
  {
    nombre: 'Dr. Carlos T.',
    pais: 'Argentina 🇦🇷',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/bbd293ff-dace-41bd-8b11-68b75bc04434.jpg',
    texto:
      'Lo más valioso no son solamente los protocolos. Es la tranquilidad de saber exactamente qué hacer en cada escenario. Esa confianza también la perciben mis pacientes.',
  },
]

export const faqs = [
  {
    q: '¿La Ruta Fertilidad Masculina es un curso en video?',
    a: 'No. Es un sistema de consulta clínica en formato digital, diseñado para que encuentres respuestas rápidamente cuando las necesites. Puedes estudiarlo de principio a fin o utilizarlo como guía durante tu práctica profesional.',
  },
  {
    q: '¿Recibiré acceso inmediatamente después del pago?',
    a: 'Sí. Una vez confirmado tu pago recibirás acceso inmediato para descargar todo el material y comenzar a utilizarlo ese mismo día.',
  },
  {
    q: '¿Está dirigido únicamente a urólogos?',
    a: 'No. La Ruta fue diseñada para médicos generales, urólogos, endocrinólogos, especialistas en medicina reproductiva, residentes y cualquier profesional de la salud que participe en la evaluación y manejo de pacientes con infertilidad masculina.',
  },
  {
    q: '¿El contenido está basado en evidencia científica?',
    a: 'Sí. Todo el material se desarrolló utilizando guías clínicas internacionales, revisiones científicas y literatura médica actualizada, priorizando siempre las recomendaciones con mayor respaldo disponible.',
  },
  {
    q: '¿Necesito tener experiencia previa en andrología?',
    a: 'No. La Ruta está organizada para acompañarte paso a paso, tanto si estás comenzando a atender pacientes con infertilidad masculina como si ya tienes experiencia y deseas estructurar mejor tu toma de decisiones.',
  },
  {
    q: '¿Durante cuánto tiempo tendré acceso?',
    a: 'El acceso es de por vida. Podrás descargar el material y consultarlo siempre que lo necesites, sin pagos mensuales ni renovaciones.',
  },
  {
    q: '¿Qué sucede si el material no cumple mis expectativas?',
    a: 'Estás protegido por una garantía de 7 días. Si consideras que la Ruta no aporta el valor esperado, solo debes escribirnos dentro del período de garantía y te devolveremos el 100% de tu dinero.',
  },
  {
    q: '¿Este material reemplaza una especialidad médica?',
    a: 'No. Es un recurso educativo diseñado para organizar y facilitar la toma de decisiones clínicas. No reemplaza la formación especializada, el juicio clínico ni las guías oficiales: los complementa para ayudarte a trabajar con mayor seguridad y eficiencia.',
  },
]

export const compradores = [
  { nombre: 'Dra. Valentina R.', pais: 'Colombia' },
  { nombre: 'Dr. Andrés M.', pais: 'México' },
  { nombre: 'Dra. Camila S.', pais: 'Argentina' },
  { nombre: 'Dr. Sebastián L.', pais: 'Chile' },
  { nombre: 'Dra. Lucía F.', pais: 'España' },
  { nombre: 'Dr. Mateo G.', pais: 'Perú' },
  { nombre: 'Dra. Daniela C.', pais: 'Ecuador' },
  { nombre: 'Dr. Rodrigo P.', pais: 'Uruguay' },
  { nombre: 'Dra. Fernanda T.', pais: 'Costa Rica' },
  { nombre: 'Dr. Ignacio B.', pais: 'Paraguay' },
  { nombre: 'Dra. Paula N.', pais: 'República Dominicana' },
  { nombre: 'Dr. Emilio V.', pais: 'Guatemala' },
  { nombre: 'Dra. Sofía A.', pais: 'Panamá' },
  { nombre: 'Dr. Julián H.', pais: 'Bolivia' },
  { nombre: 'Dra. Renata O.', pais: 'Venezuela' },
]
